/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Reasons_Dealstructurenotsuitable5Inputs */

const en_coinvestments_declinedeal_reasons_dealstructurenotsuitable5 = /** @type {(inputs: Coinvestments_Declinedeal_Reasons_Dealstructurenotsuitable5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opportunity structure not suitable`)
};

/**
* | output |
* | --- |
* | "Opportunity structure not suitable" |
*
* @param {Coinvestments_Declinedeal_Reasons_Dealstructurenotsuitable5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_reasons_dealstructurenotsuitable5 = /** @type {((inputs?: Coinvestments_Declinedeal_Reasons_Dealstructurenotsuitable5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Reasons_Dealstructurenotsuitable5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_reasons_dealstructurenotsuitable5(inputs)
});
export { coinvestments_declinedeal_reasons_dealstructurenotsuitable5 as "coInvestments_declineDeal_reasons_dealStructureNotSuitable" }